module.exports = __webpack_public_path__ + "media/img/ruby-ico-no-shadow-b2aac5b3.png";